import {
  observable,
  transaction,
  map,
  computed,
  autorun,
  runInAction,
  action
} from 'mobx';

export default class ColumnSet {
  store;

  @observable items;

  @computed get displayColumn() {
    // return this.items.find(it => it.field === 'Name') || this.items.find(it => it.field === 'Code') || this.items.find(it => it.field === 'ID') || this.items[0];
    let refShowField = this.store.refShowField && this.store.refShowField.split('+');

    return refShowField && refShowField.length > 0 ?
      this.items.filter(it => refShowField.indexOf(it.field) > -1)
      :
      (this.items.filter(it => it.field === 'Name') || this.items.filter(it => it.field === 'Code') || this.items.filter(it => it.field === 'ID') || [this.items[0]]);
  }

  constructor(store, items = []) {
    this.store = store;
    this.items = items
  }

  static fromJS(store, obj = {}) {
    let fields;
    if (obj.userFields && obj.userFields.length > 0) {
      fields = obj.userFields;
    } else {
      fields = obj.dropDownFields;
    }
    if (!fields || fields.length <= 0) {
      fields = obj.allFields;
    }
    return new ColumnSet(store, fields.filter(it => it.display));
  }

  static Enums(store) {
    return new ColumnSet(store, [{
      field: "Name",
      caption: "名称",
      display: true
    }, {
      field: "Code",
      caption: "编码",
      display: true
    }, {
      field: "Id",
      caption: "ID",
      display: true
    }]);
  }

}
